/**
 * The vertical buffer ratio allowed between two items
 * @type {Number}
 */
export const VERTICAL_BUFFER_RATIO = 0.15;
